import { UserInterface } from '../interfaces/user';

export const setUrlText = (tu: string, pp: string): void => {
  MdHub.command.send('platform.notification', 'setUrlText', {
    links: {
      tu: {
        link: tu,
        document_name: 'Termos de Uso',
        document_type: 'tu',
      },
      pp: {
        link: pp,
        document_name: 'Política de Privacidade',
        document_type: 'pp',
      },
    },
    text: 'Tivemos atualizações em nossos ',
  });
};

export const setPrivacyUser = (user: UserInterface, token: string): void => {
  MdHub.command.send('platform.notification', 'setUser', {
    ...user,
    token,
    origin: 'dispenser',
  });
};

export const resetPrivacyState = (): void => {
  MdHub.command.send('platform.notification', 'resetState', {});
};
